/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ProfileUpdateRequestDocumentTheme } from './profileUpdateRequestDocumentTheme';

export interface ProfileUpdateRequest {
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  timezone?: string | null;
  document_theme?: ProfileUpdateRequestDocumentTheme;
}
